import { useState } from "react";
import { EventPanel } from "./EventPanel";
import { RallyEventPanel } from "./RallyEventPanel";
import { RallyPointPanel } from "./RallyPointPanel";

/**
 * 🎁 행사·랠리 — 세 패널을 탭으로 나눈다.
 *
 * 예전엔 셋을 한 화면에 세로로 쌓아서 **아래 저장 바에 저장 버튼이 3개**(행사 일정 · 랠리 선물 ·
 * 랠리 지점) 나란히 떴다. "어느 걸 눌러야 하지"가 되는 자리다 — 저장은 화면당 하나여야 한다.
 * 각 패널은 자기가 보일 때만 `useRegisterSave` 를 걸므로, 탭으로 나누면 버튼도 하나만 뜬다.
 *
 * [🧸 캐릭터]와 같은 해법이고 같은 스타일 조각(`chub__tabs`)을 쓴다 — 관리자 안에서
 * 탭이 두 종류로 보이면 그것도 배워야 할 것이 하나 느는 셈이다.
 */
const TABS = [
  { id: "event", icon: "🎪", label: "행사 일정", hint: "언제 무엇을 하는지" },
  { id: "gift", icon: "🎁", label: "랠리 선물", hint: "완주 선물·인원·신청" },
  { id: "point", icon: "📍", label: "랠리 지점", hint: "어디에서 도장을 찍는지" },
] as const;
type TabId = (typeof TABS)[number]["id"];

export function EventRallyTabs() {
  // 새로고침해도 보던 탭 유지(다른 관리자 화면과 같은 방식)
  const [tab, setTab] = useState<TabId>(
    () => (localStorage.getItem("gc_admin_rally_tab") as TabId) || "event",
  );
  const pick = (t: TabId) => {
    setTab(t);
    localStorage.setItem("gc_admin_rally_tab", t);
  };

  return (
    <section className="panel">
      <div className="chub__tabs" role="tablist">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={tab === t.id}
            className="chub__tab"
            data-on={tab === t.id || undefined}
            onClick={() => pick(t.id)}
          >
            <span aria-hidden="true">{t.icon}</span> {t.label}
            <small>{t.hint}</small>
          </button>
        ))}
      </div>

      <div className="chub__body">
        {tab === "event" ? <EventPanel /> : tab === "gift" ? <RallyEventPanel /> : <RallyPointPanel />}
      </div>
    </section>
  );
}
